import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import adminsReducer from '../features/admins/adminsSlice';
import deliveriesReducer from '../features/deliveries/deliveriesSlice';
import orderUploadReducer from '../features/deliveries/orderUploadSlice';
import sellersReducer from '../features/sellers/sellersSlice';
import sellerDetailsReducer from '../features/sellers/sellerDetailsSlice';
import partnershipsReducer from '../features/partnerships/partnershipsSlice';
import upsellingReducer from '../features/upselling/upsellingSlice';
import couriersReducer from '../features/couriers/couriersSlice';
import externalIntegrationsReducer from '../features/externalIntegrations/externalIntegrationsSlice';
import orderDetailsReducer from '../features/orderDetails/orderDetailsSlice';
import deliveryItemsReducer from '../features/deliveryItems/deliveryItemsSlice';
import zonesReducer from '../features/zones/zonesSlice';
import pickupsReducer from '../features/pickups/pickupsSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import connectionReducer from '../features/connection/connectionSlice';
import attentionReducer from '../features/attention/attentionSlice';
import geoReducer from '../features/geo/geoSlice';
import userReducer from '../features/user/userSlice';
import ecommercesReducer from '../features/ecommerces/ecommercesSlice';
import webhooksReducer from '../features/webhooks/webhooksSlice';
import pickupRequestsReducer from '../features/pickupRequests/pickupRequestsSlice';
import trackingReducer from '../features/tracking/trackingSlice';
import feedbackReducer from '../features/feedback/feedbackSlice';
import warehouseContextReducer from '../features/warehouseContext/warehouseContextSlice';
import stockReducer from '../features/stock/stockSlice';
import stockKardexReducer from '../features/stock/stockKardexSlice';
import movementsReducer from '../features/movements/movementsSlice';
import slotsReducer from '../features/slots/slotsSlice';
import catalogReducer from '../features/catalog/catalogSlice';
import stockSyncReducer from '../features/stockSync/stockSyncSlice';
import receiptsReducer from '../features/receipts/receiptsSlice';
import suppliesReducer from '../features/supplies/suppliesSlice';
import putawayReducer from '../features/putaway/putawaySlice';
import wmsOrdersReducer from '../features/wmsOrders/wmsOrdersSlice';
import fulfillmentReducer from '../features/fulfillment/fulfillmentSlice';
import warehouseClientsReducer from '../features/warehouseClients/warehouseClientsSlice';
import pickupPointsReducer from '../features/pickupPoints/pickupPointsSlice';
import operatorReducer from '../features/operator/operatorSlice';
import operatorDeviceReducer from '../features/operator/operatorDeviceSlice';
import operatorReceivingReducer from '../features/operatorReceiving/operatorReceivingSlice';
import operatorPutawayReducer from '../features/operatorPutaway/operatorPutawaySlice';
import operatorPickingReducer from '../features/operatorPicking/operatorPickingSlice';
import operatorPickingRouteReducer from '../features/operatorPicking/operatorPickingRouteSlice';
import operatorPackingReducer from '../features/operatorPacking/operatorPackingSlice';
import operatorDispatchReducer from '../features/operatorDispatch/operatorDispatchSlice';
import operatorKitsReducer from '../features/operatorKits/operatorKitsSlice';
import operatorTasksReducer from '../features/operatorTasks/operatorTasksSlice';

const rootReducer = combineReducers({
  ecommerces: ecommercesReducer,
  webhooks: webhooksReducer,
  pickupRequests: pickupRequestsReducer,
  auth: authReducer,
  admins: adminsReducer,
  deliveries: deliveriesReducer,
  orderUpload: orderUploadReducer,
  sellers: sellersReducer,
  sellerDetails: sellerDetailsReducer,
  partnerships: partnershipsReducer,
  upselling: upsellingReducer,
  couriers: couriersReducer,
  externalIntegrations: externalIntegrationsReducer,
  orderDetails: orderDetailsReducer,
  deliveryItems: deliveryItemsReducer,
  zones: zonesReducer,
  pickups: pickupsReducer,
  notifications: notificationsReducer,
  dashboard: dashboardReducer,
  connection: connectionReducer,
  attention: attentionReducer,
  geo: geoReducer,
  user: userReducer,
  tracking: trackingReducer,
  feedback: feedbackReducer,
  warehouseContext: warehouseContextReducer,
  stock: stockReducer,
  stockKardex: stockKardexReducer,
  movements: movementsReducer,
  slots: slotsReducer,
  catalog: catalogReducer,
  stockSync: stockSyncReducer,
  receipts: receiptsReducer,
  supplies: suppliesReducer,
  putaway: putawayReducer,
  wmsOrders: wmsOrdersReducer,
  fulfillment: fulfillmentReducer,
  warehouseClients: warehouseClientsReducer,
  pickupPoints: pickupPointsReducer,
  operator: operatorReducer,
  operatorDevice: operatorDeviceReducer,
  operatorReceiving: operatorReceivingReducer,
  operatorPutaway: operatorPutawayReducer,
  operatorPicking: operatorPickingReducer,
  operatorPickingRoute: operatorPickingRouteReducer,
  operatorPacking: operatorPackingReducer,
  operatorDispatch: operatorDispatchReducer,
  operatorKits: operatorKitsReducer,
  operatorTasks: operatorTasksReducer,
  // Módulos futuros:
  // driverRoutes: driverRoutesReducer
});

export default rootReducer;
